import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-my-profile-favorites',
  templateUrl: './admin-my-profile-favorites.component.html',
  styleUrls: ['./admin-my-profile-favorites.component.scss']
})
export class AdminMyProfileFavoritesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
